import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class AmendChequePurposeService {
  constructor(private http: HttpUtilService) {}

  AmmendChequePurposeService(chequeNumber: string): Observable<any> {
    const encodedChequeNumber = encodeURIComponent(
      `"${chequeNumber}"`,
    );
    const url = `AmmendChequePurposeService.asmx/GetOldPurpose?chequeNumber=${encodedChequeNumber}`;
    return this.http.get(url);
  }

  GetAllAccountCode(): Observable<any> {
    return this.http.get(
      "AmmendChequePurposeService.asmx/GetAllAccountCode",
    );
  }

  UpdatePurpose(
    chequeNumber: string,
    purpose: string,
  ): Observable<any> {
    return this.http.post(
      "AmmendChequePurposeService.asmx/UpdatePurpose",
      {
        chequeNumber,
        purpose,
      },
    );
  }
}
